import React, { useState } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { YES_NO_DEFAULT } from './selector';
import {
  ChangeContactInformationField,
  ChangeContactInformationFieldHeader,
  ChangeContactInformationNumericInputField,
  ChangeContactInformationTextAreaInputField,
  RequiredField,
} from './styles';

const yesNoOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const AdditionSubQuestionField = props => {
  const { q, parentIndex, index, setAdditionalSubQuestionsAnswers } = props;
  const yesNoInitialState = q.defaultValue || YES_NO_DEFAULT;
  const [selectedYesNoValue, setSelectedYesNoValue] = useState({
    label: yesNoInitialState,
    value: yesNoInitialState,
  });
  const [numericInputValue, setNumericInputValue] = useState('');

  const getInputField = type => {
    let input;
    switch (type) {
      case 'YesNo':
        input = (
          <Select
            options={yesNoOptions}
            value={selectedYesNoValue}
            onChange={selectedValue => {
              setSelectedYesNoValue(selectedValue);
              setAdditionalSubQuestionsAnswers(parentIndex, index, selectedValue);
            }}
          />
        );
        break;
      case 'Numeric':
        input = (
          <ChangeContactInformationNumericInputField
            value={numericInputValue}
            onChange={e => {
              setNumericInputValue(e.target.value);
              setAdditionalSubQuestionsAnswers(parentIndex, index, e.target.value);
            }}
          />
        );
        break;
      case 'TextArea':
        input = (
          <ChangeContactInformationTextAreaInputField
            value={numericInputValue}
            onChange={e => {
              setNumericInputValue(e.target.value);
              setAdditionalSubQuestionsAnswers(parentIndex, index, e.target.value);
            }}
          />
        );
        break;
      default:
        input = null;
    }
    return input;
  };

  return (
    <ChangeContactInformationField key={q.name}>
      <ChangeContactInformationFieldHeader>
        {q.text}
        {q.requiredInd === 'Yes' && <RequiredField>*</RequiredField>}
      </ChangeContactInformationFieldHeader>
      {getInputField(q.dataType)}
    </ChangeContactInformationField>
  );
};
AdditionSubQuestionField.propTypes = {
  q: PropTypes.object,
  index: PropTypes.number,
  parentIndex: PropTypes.number,
  setAdditionalSubQuestionsAnswers: PropTypes.func,
};

const mapStateToProps = state => ({
  state,
});

export default connect(mapStateToProps)(AdditionSubQuestionField);
